import { ResponseError } from 'src/shared/types';

export const handleAddToReservationListErrors = (err: ResponseError): string[] | null => {
    const flattedErrors = Object.values(err?.error?.response?.data?.errors).flat();
    if (Array.isArray(flattedErrors) && flattedErrors.length) {
        return flattedErrors;
    }
    return ['unknownError'];
};
